import { render, staticRenderFns } from "./detailBox.vue?vue&type=template&id=5b00a869&"
import script from "./detailBox.vue?vue&type=script&lang=ts&"
export * from "./detailBox.vue?vue&type=script&lang=ts&"
import style0 from "./detailBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports